import React, { createContext, useContext, useMemo } from "react";
import { useAppContext } from "./AppContext";

export const StationsContext = createContext({
    stations: [],
    loadingStations: true,
    getStationName: (code) => code,
});

export const useStationsContext = () => useContext(StationsContext);

export const StationsContextProvider = ({ children }) => {
    const { customer, loadingCustomer } = useAppContext();

    const stationsData = useMemo(() => {
        // Extract stations from customer.stations or customer.customer.stations
        const rawStations = customer?.stations || customer?.customer?.stations || [];
        
        console.log("StationsContext - customer:", customer);
        console.log("StationsContext - rawStations:", rawStations);
        
        // Create a map: id -> stationName for lookups
        const stationMap = {};
        const stationIds = [];
        
        rawStations.forEach(station => {
            if (station?.id && station?.stationName) {
                stationMap[station.id] = station.stationName;
                stationIds.push(station.id);
            }
        });

        console.log("StationsContext - stationIds:", stationIds);

        // Function to get station name by ID (returns the stored stationName for API calls)
        const getStationName = (stationId) => {
            if (!stationId) return '';
            // Return the stored station name (should match StationNameEnum values like TENGALI, CHIKKAMYAGERI, etc.)
            return stationMap[stationId] || stationId;
        };

        return {
            stations: stationIds,
            loadingStations: loadingCustomer,
            getStationName,
        };
    }, [customer, loadingCustomer]);

    return (
        <StationsContext.Provider value={stationsData}>
            {children}
        </StationsContext.Provider>
    );
};
